// extracted by mini-css-extract-plugin
export default {"optionCard":"optionMenu_optionCard__s7dwW","optionCardPT":"optionMenu_optionCardPT__p03mj","backIcon":"optionMenu_backIcon__IHNMh","cancelIcon":"optionMenu_cancelIcon__B0b6V"};